<template>
    <b-overlay :id="coverDomId" spinner-variant="primary" :show="loading"
               class="w-100 h-100 overflow-hidden">
        <div class="position-relative w-100 h-100" :class="enableResize ? (`resize-${enableResize}`) : ''">
            <common-chart ref="lineChart" v-bind="$attrs" class="w-100 h-100" :options="options"></common-chart>
            <slot></slot>
        </div>
    </b-overlay>
</template>

<script>
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "LineChart",
    components: {CommonChart},
    mixins: [emCommonUtilMixin],
    props: {
        data: Object,
        title: {
            type: String,
            default: ""
        },
        xAxis: {
            type: Array,
            default: () => []
        },
        enableResize: String,//vertical/horizontal/both
        loading: {
            type: Boolean,
            default: false
        },
        id: [String, Number]
    },
    computed: {
        series() {
            let temp = [];
            if (this.data) {
                for (let item in this.data) {
                    temp.push({
                        name: item,
                        type: 'line',
                        symbol: 'none',
                        sampling: 'lttb',
                        lineStyle: {
                            width: 3,
                            shadowColor: 'rgba(0,0,0,0.3)',
                            shadowBlur: 10,
                            shadowOffsetY: 8
                        },
                        data: this.data[item]
                    })
                }
            }
            return temp;
        },
        options() {
            return {
                title: {
                    text: this.title
                },
                tooltip: {
                    trigger: 'axis',
                    confine: true
                },
                legend: {
                    show: true
                },
                grid: {
                    left: '20px',
                    right: '20px',
                    top: '30px',
                    bottom: '0',
                    containLabel: true
                },
                xAxis: {
                    type: 'time',
                    // data: this.xAxis,
                    axisLabel: {
                        formatter: {
                            hour: '{boldStyle|{HH}:{mm}}',
                            minute: '{boldStyle|{HH}:{mm}}',
                            second: '{secondStyle|{ss}s}',
                        },
                        rich: {
                            secondStyle: {
                                color: '#aaaaaa',
                            },
                            boldStyle: {
                                color: '#333',
                                fontWeight: 'bold'
                            }
                        }
                    }
                },
                yAxis: {
                    type: 'value'
                },
                // dataZoom: [
                //     {
                //         type: 'slider',
                //         xAxisIndex: 0,
                //         filterMode: 'none',
                //         brushSelect: false,
                //         height: 15,
                //         bottom: 0,
                //         showDetail: false,
                //         minValueSpan: 60 * 1000,
                //     },
                //     {
                //         type: 'slider',
                //         yAxisIndex: 0,
                //         filterMode: 'none',
                //         brushSelect: false,
                //         width: 15,
                //         left: 0,
                //         showDetail: false
                //     },
                //     {
                //         type: 'inside',
                //         xAxisIndex: 0,
                //         filterMode: 'none'
                //     },
                // ],
                series: this.series
            }
        },
        coverDomId() {
            return `stack_cover_${this.id ? this.id : this.genNonDuplicateID(4)}`;
        },
    },
    mounted() {
        if (this.enableResize) {
            this.listenDomResize();
        }
    },
    methods: {
        listenDomResize() {
            if ("MutationObserver" in window) {
                this.$store.state.customizedDiagram.domResizeObserver.observe(document.getElementById(this.coverDomId), {
                    attributes: true,
                    attributeFilter: ['class', 'style']
                });
            }
        },
        resizeChart() {
            this.$refs.lineChart.resize();
        },
    }
}
</script>

<style scoped>
.resize-vertical {
    resize: vertical;
}

.resize-horizontal {
    resize: horizontal;
}

.resize-both {
    resize: both;
}
</style>
